import { render, staticRenderFns } from "./wilds.vue?vue&type=template&id=3b1ac6c0&"
import script from "./wilds.vue?vue&type=script&lang=js&"
export * from "./wilds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports